import 'mmenu-js';

document.addEventListener(
    "DOMContentLoaded", () => {

        const social = document.querySelector("#social");
        const shortcuts = document.querySelector("#shortcuts");
        //const switchlang = document.querySelector("#langswitcher");
        const toggler = document.querySelector('.navbar-toggler');

        const mmenu = new Mmenu( "#topmenu", {
            // options
            hooks: {
                'open:start': () => {
                    toggler.classList.add('open');
                },
                'close:start': () => {
                    toggler.classList.remove('open');
                },
            },
            extensions: ["theme-light", "border-none", "pagedim-white"],
            navbars: [
                /*
                {
                    position: "top",
                    content: [
                       switchlang
                    ]
                 },
                */
                {
                   position: "bottom",
                   content: [
                      social,
                      shortcuts
                   ]
                }
             ],
            slidingSubmenus: true            

        }, {
            // configuration
            offCanvas: {
                page: {
                    selector: "#wrapper"
                }
            }

        });

        const api = mmenu.API;

        const topMenu = document.querySelector( "#topmenu" );

        /*
        topMenu.querySelectorAll(".menu-item-has-children").forEach(item => {
            let listitem__text = item.querySelector('.mm-listitem__text');
            let listitem__btn = item.querySelector('.mm-listitem__btn');
            
            let listitem__text_href = listitem__text.getAttribute("href");
            let listitem__btn_href = listitem__btn.getAttribute("href");
            
            listitem__text.setAttribute("data-href", listitem__text_href);
            listitem__text.setAttribute("href", listitem__btn_href);
        });
        */

    }
);